import React, { useEffect } from "react";
import ReactDOM from "react-dom/client";
import "./index.scss";
import reportWebVitals from "./reportWebVitals";
import {
  createBrowserRouter,
  Outlet,
  RouterProvider,
} from "react-router-dom";
import { store } from "./store/store";
import { Provider, useDispatch } from "react-redux";
import Index from "./pages";
import "./font.scss";
import CuratorPage from "./pages/curator";
import TeamList from "./pages/teamList";
import PlayerList from "./pages/playerList";
import BiddingPage from "./pages/biddingPage";
import ViewAllPlayers from "./pages/viewAllPlayers";
import PlayerListActive from "./pages/playerListActive";
import UrlLoginBidder from "./pages/urlLoginBidder";
import UrlLoginCurator from "./pages/urlLoginCurator";
import io from "socket.io-client";
import { getProfile as CuratorProfile } from "./store/features/curatorSlice";
import { getProfile as BidderProfile } from "./store/features/bidderSlice";
import AllPlayers from "./pages/biddingPage/allPlayers";
import AllPlayersListGeneral from "./pages/playerListGeneral";
import TeamListGeneral from "./pages/teamListGeneral";
import CuratorLogin from "./pages/LoginPages/CuratorLogin";
import BidderLogin from "./pages/LoginPages/BidderLogin";
import Landing from "./pages/landing";
import { backendDomain } from "./store/paths";

let socket = io.connect(backendDomain);

const Redirect = (props) => {
  console.log(props.url);
  useEffect(() => {
    window.location.href = props.url;
  }, [props.url]);
  return <h5>Loading</h5>;
};

export default Redirect;

const router = createBrowserRouter([
  {
    path: "/",
    element: <Landing />,
  },
  {
    path: "/live/:sessionId",
    element: <Index socket={socket} />,
    // errorElement: <div>wrong page</div>,
  },
  {
    path: "/admin",
    element: <>{<Redirect url="https://auctionadmin.spectors.in" />}</>,
    // errorElement: <div>wrong page</div>,
  },
  {
    path: "/curator/login",
    element: <CuratorLogin socket={socket} />,
    // errorElement: <div>wrong page</div>,
  },
  {
    path: "/bidder/login",
    element: <BidderLogin socket={socket} />,
    // errorElement: <div>wrong page</div>,
  },
  {
    path: "/playerlist",
    element: <AllPlayersListGeneral socket={socket} />,
    // errorElement: <div>wrong page</div>,
  },
  {
    // The live board links here for the auction it is showing, so anyone
    // watching can open the full pool without signing in.
    path: "/playerlist/:sessionId",
    element: <AllPlayersListGeneral socket={socket} />,
    // errorElement: <div>wrong page</div>,
  },
  {
    // The public squad board. Same share link shape as the pool: the session
    // id is the whole key, so anyone watching can open it without signing in.
    path: "/teams/:sessionId",
    element: <TeamListGeneral socket={socket} />,
  },
  {
    path: "curator/auction",
    element: (
      <>
        <CuratorPage socket={socket} />
        <Outlet />
      </>
    ),
  },
  {
    path: "curator",
    element: (
      <>
        <UrlLoginCurator />
      </>
    ),
  },
  {
    path: "curator/teamlist",
    element: (
      <>
        <TeamList socket={socket} />
        <Outlet />
      </>
    ),
  },
  {
    path: "curator/playerlist",
    element: (
      <>
        <PlayerList socket={socket} />
        <Outlet />
      </>
    ),
  },
  {
    path: "curator/auction/playerlist",
    element: (
      <>
        <PlayerListActive socket={socket} />
        <Outlet />
      </>
    ),
  },
  {
    path: "bidder",
    element: (
      <>
        <UrlLoginBidder />
      </>
    ),
  },
  {
    path: "bidder/bidding",
    element: (
      <>
        <BiddingPage socket={socket} />
        <Outlet />
      </>
    ),
  },
  {
    path: "bidder/teamview",
    element: (
      <>
        <ViewAllPlayers socket={socket} />
        <Outlet />
      </>
    ),
  },
  {
    path: "bidder/allplayers",
    element: (
      <>
        <AllPlayers socket={socket} />
        <Outlet />
      </>
    ),
  },
]);

const App = () => {
  let dispatch = useDispatch();

  useEffect(() => {
    dispatch(CuratorProfile());
    dispatch(BidderProfile());
  });

  return <RouterProvider router={router} />;
};

const root = ReactDOM.createRoot(document.getElementById("root"));

// REACT_APP_PREVIEW swaps the whole app for the throwaway harness in
// devPreview.js, which renders each screen against made-up data.
//
// The NODE_ENV half is what keeps the harness and its fake league out of the
// production bundle: webpack substitutes that constant at build time, so the
// whole branch - the require included - is pruned from a `npm run build`.
if (process.env.NODE_ENV !== "production" && process.env.REACT_APP_PREVIEW) {
  const DevPreview = require("./devPreview").default;
  root.render(<DevPreview />);
} else {
  root.render(
    <React.StrictMode>
      <Provider store={store}>
        <App />
      </Provider>
    </React.StrictMode>
  );
}

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
